import { Routes } from '@angular/router';
import { RouteResolver } from '@df/catalog/route/route.resolver';

export const catalogRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "catalog-view.async" */
                './catalog-view.component'
            ).then(m => m.CatalogViewComponent),
        resolve: {
            route: RouteResolver
        },
        data: {
            preload: true
        }
    }
];
